export default __webpack_public_path__ + "static/RichardMcPherson-73addebcdd7a4339dd23bc9d8488431d.jpg";